module.exports = __webpack_public_path__ + "img/progress_big.7ff1a837.svg";